/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestAmazonItem
 */
export interface RequestAmazonItem {
    /**
     * 
     * @type {number}
     * @memberof RequestAmazonItem
     */
    actualShippingCount?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestAmazonItem
     */
    fnskuCode?: string;
}

/**
 * Check if a given object implements the RequestAmazonItem interface.
 */
export function instanceOfRequestAmazonItem(value: object): value is RequestAmazonItem {
    return true;
}

export function RequestAmazonItemFromJSON(json: any): RequestAmazonItem {
    return RequestAmazonItemFromJSONTyped(json, false);
}

export function RequestAmazonItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestAmazonItem {
    if (json == null) {
        return json;
    }
    return {
        
        'actualShippingCount': json['actual_shipping_count'] == null ? undefined : json['actual_shipping_count'],
        'fnskuCode': json['fnsku_code'] == null ? undefined : json['fnsku_code'],
    };
}

export function RequestAmazonItemToJSON(json: any): RequestAmazonItem {
    return RequestAmazonItemToJSONTyped(json, false);
}

export function RequestAmazonItemToJSONTyped(value?: RequestAmazonItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actual_shipping_count': value['actualShippingCount'],
        'fnsku_code': value['fnskuCode'],
    };
}

